/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssignmentConflictResponseDto } from './AssignmentConflictResponseDto';
import {
    AssignmentConflictResponseDtoFromJSON,
    AssignmentConflictResponseDtoFromJSONTyped,
    AssignmentConflictResponseDtoToJSON,
    AssignmentConflictResponseDtoToJSONTyped,
} from './AssignmentConflictResponseDto';

/**
 * 
 * @export
 * @interface ListAssignmentConflictsResponseDto
 */
export interface ListAssignmentConflictsResponseDto {
    /**
     * 
     * @type {Array<AssignmentConflictResponseDto>}
     * @memberof ListAssignmentConflictsResponseDto
     */
    data: Array<AssignmentConflictResponseDto>;
}

/**
 * Check if a given object implements the ListAssignmentConflictsResponseDto interface.
 */
export function instanceOfListAssignmentConflictsResponseDto(value: object): value is ListAssignmentConflictsResponseDto {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListAssignmentConflictsResponseDtoFromJSON(json: any): ListAssignmentConflictsResponseDto {
    return ListAssignmentConflictsResponseDtoFromJSONTyped(json, false);
}

export function ListAssignmentConflictsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListAssignmentConflictsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(AssignmentConflictResponseDtoFromJSON)),
    };
}

export function ListAssignmentConflictsResponseDtoToJSON(json: any): ListAssignmentConflictsResponseDto {
    return ListAssignmentConflictsResponseDtoToJSONTyped(json, false);
}

export function ListAssignmentConflictsResponseDtoToJSONTyped(value?: ListAssignmentConflictsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(AssignmentConflictResponseDtoToJSON)),
    };
}

